import React from 'react'
// import { useHistory } from 'react-router-dom'

import { Container, Row, Col, Button } from 'react-bootstrap'
import moment from 'moment'

import SmallLogo from '../../components/SmallLogo'

import Styles from './AboutScreen.module.scss'

const AboutScreen = () => {
  // let history = useHistory()

  const signHandler = () => {
    window.location.href = "https://beyondthewhiteboard.com/earned/challenges/3"
  }

  const isClosed = () => {
    return moment('2021-12-13 19:59:59-07:00').isBefore(moment());
  }

  return (
    <Container fluid className={Styles.gradient}>
      <Row>
        <Col>
          <div className={Styles.about}>
            <Row>
              <Col md={6} className={Styles.left}>
                <h2>About The Masters Throwdown</h2>
                <p>
                  Welcome to the PRVN Fitness / Masters Throwdown presented by btwb. This is a global competition available for all Masters athletes of all abilities to sign up and showcase their fitness. This challenge is about community and giving the Masters athletes of our sport an opportunity to test themselves alongside one another and share in the success that comes with competitions.
                </p>
              </Col>
              <Col md={6} className={Styles.right}>
                <div className={Styles.content}>
                  <h2>Fran</h2>
                  <p>December 10 at 6am PST - December 13 at 5pm PST</p>
                  <p className={Styles.soon + ' ' + (isClosed() ? Styles.closed : '')}>{isClosed() ? 'Challenge Is Closed' : 'Challenge Is Live!'}</p>


                  {!isClosed() &&
                    <div className={Styles.action}>
                      <Button
                        variant='primary'
                        className={Styles.btn}
                        onClick={signHandler}
                      >
                        Sign up
                      </Button>

                    </div>
                  }

                  <div className={Styles.logos}>
                    <SmallLogo
                      topTitle='charity'
                      className={Styles.charity}
                      imageName="charity"
                    />
                    <p>Formerly known as Steve’s Club National Program, Forging Youth Resilience (FYR) is a member-based 501(c)(3) nonprofit organization that partners with fitness facilities nationwide to bring fitness, nutrition, and mentorship to youth who otherwise would not have access to these services.</p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default AboutScreen
